<template>
  <div>
    <v-card class="pa-3">
      <div class="text-xs-right">
        <v-btn icon flat ripple @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div>
        <h5>ประวัติการทำรายการ</h5>
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template #items="props">
            <tr>
              <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.actions }}</td>
              <td>{{ props.item.transfer_to || 'system' }}</td>
              <td>{{ props.item.admin_id || 'system' }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: 'วันเวลา', value: 'date', sortable: false },
        { text: 'สถานะ', value: 'status', sortable: false },
        { text: 'Action', value: 'name', sortable: false },
        { text: 'Assignee', value: 'name', sortable: false },
        { text: 'ผู้ทำรายการ', value: 'name', sortable: false }
      ],
      items: this.value
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/HistoryStatus.vue